/*  */
import Button from 'components/ButtonDeprecated';
import Buttons from 'components/Buttons';
import Container from 'components/Container';
import ChangeUntrustedNameModal from 'chat/components/ChangeUntrustedNameModal';
import ModalTrigger from 'components/ModalTrigger';
import * as React from 'react';
import RelationshipActions from 'actions/RelationshipActions';
import Subscriber from 'entities/Subscriber';

class RelationshipViewUntrustedName extends React.Component<{
  subscriber: Subscriber;
}> {
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  handleConfirmSubscriberName = (event) => {
    event.preventDefault();
    RelationshipActions.confirmUntrustedName(this.props.subscriber.id);
  };

  render() {
    const { subscriber } = this.props;

    if (!subscriber.getUntrustedName()) {
      return null;
    }

    // $FlowFixMe the modal requires onRequestHide, which isn't supplied until ModalTrigger
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    const changeUntrustedNameModal = <ChangeUntrustedNameModal subscriber={subscriber} />;

    return (
      <div className="RelationshipView-untrustedName">
        <h3 className="RelationshipView-untrustedName-title">Is this person’s name correct?</h3>
        <Container size="xxsmall">
          <Buttons full>
            <Button
              level="primary"
              size="xsmall"
              color="mascot"
              onClick={this.handleConfirmSubscriberName}
            >
              Yes
            </Button>
            <ModalTrigger modal={changeUntrustedNameModal}>
              <Button level="primary" size="xsmall" color="mascot">
                No
              </Button>
            </ModalTrigger>
          </Buttons>
        </Container>
      </div>
    );
  }
}
export default RelationshipViewUntrustedName;
